/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import Shell from '../../common/components/Shell/Shell';
import { Grid } from '@mui/material';
import PerfomancePresenter from './PerfomancePresenter';
import DTOPerfomance from './DTOPerfomance';
import { useAppSelector } from '../../infra/hooks';
import { useTranslation } from 'react-i18next';

function PerfomanceController() {
  const { t, i18n } = useTranslation();

  const [empDirectory, setempDirectory] = useState([]);
  const [allDepartment, setallDepartment] = useState([]);
  const [pageNumber, setPageNumber] = useState<any>(0);
  const [totalEmpDirectory, setTotalEmpDirectory] = useState<any>(0);

  const isLoading = useAppSelector((state) => state.LoaderSlice.Loading);
  const selector = useAppSelector((state) => state);

  function callBackFunc(data: any) {
    setempDirectory(data);
  }
  async function callBackDepartments(data: []) {
    setallDepartment(data);
  }

  function getPageNumber(data: any) {
    setPageNumber(data);
  }

  async function getTotalEmpDirectory(total: any) {
    setTotalEmpDirectory(total);
  }

  return (
    <>
      <Shell>
        <Grid
          container
          style={{
            maxWidth: 'auto',
            marginLeft: i18n.language == 'en' ? '7.25em' : '',
          }}
        >
          <PerfomancePresenter
            EmpDirectory={empDirectory}
            allDepartment={allDepartment}
            isLoading={isLoading}
            setPageChange={getPageNumber}
            totalEmpDirectory={totalEmpDirectory}
            trans={t}
            i18n={i18n}
            profilePic={selector.profilePicSlice.profilePic}
            empFirstName={selector.personalInfoSlice.firstName}
            empLastName={selector.personalInfoSlice.lastName}
            empDesignation={selector.authSlice.designaion}
          />
        </Grid>
      </Shell>
      <DTOPerfomance
        setEmpDirectory={callBackFunc}
        pageNumber={pageNumber}
        setAllDepartments={callBackDepartments}
        setTotalEmpDirectory={getTotalEmpDirectory}
      />
    </>
  );
}
export default PerfomanceController;
